import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AnyAction, Dispatch } from 'redux';
import { H3, RectangleButton } from '@shared/ui-components';
import { State } from 'common/interfaces/state';
import { AppUrls } from 'routes/app-urls';
import { AccountSelectors } from 'unit-account/selectors';
import { Styled } from './styled';

interface StateProps {
  isOwnCompanySelected: boolean;
  hasSelectedCompanyActiveSubscription: boolean;
  isSelectedCompanyLicensesLimitExceeded: boolean;
}

interface ReduxActions {
  goToProductsPage: () => void;
}

interface Props extends StateProps, ReduxActions { }

export const BillingNoticePageComponent: React.SFC<Props> = ({
  isOwnCompanySelected,
  hasSelectedCompanyActiveSubscription,
  isSelectedCompanyLicensesLimitExceeded,
  goToProductsPage,
}) => {
  let message = 'This company has no billing related issues, you\'re all good!';

  if (!isOwnCompanySelected && !hasSelectedCompanyActiveSubscription) {
    message = 'This company has no active subscription, please contact its owner for details.';
  } else if (!isOwnCompanySelected && isSelectedCompanyLicensesLimitExceeded) {
    message = 'This company has exceeded the Employee licenses limit, please contact its owner for details.';
  }


  return (
    <Styled.Container>
      <Styled.Img>
        <img src='https://takeoff.kreo.net/static/img/bug.png' />
      </Styled.Img>
      <H3>{message}</H3>
      {hasSelectedCompanyActiveSubscription && (
        <Styled.ContentContainer>
          <RectangleButton
            mood={'secondary'}
            onClick={goToProductsPage}
            text={'To The Product Page'}
            width={180}
            height={60}
          />
        </Styled.ContentContainer>
      )}
    </Styled.Container>
  );
};


function mapStateToProps(state: State): StateProps {
  const ownCompany = state.account.ownedCompany;
  const selectedCompany = state.account.selectedCompany;

  const isOwnCompanySelected = ownCompany && ownCompany.id === selectedCompany.id;

  return {
    isOwnCompanySelected,
    hasSelectedCompanyActiveSubscription: AccountSelectors.hasSelectedCompanyActiveSubscription(state),
    isSelectedCompanyLicensesLimitExceeded: AccountSelectors.isSelectedCompanyLicensesLimitExceeded(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): ReduxActions {
  return {
    goToProductsPage: () => dispatch(push(AppUrls.products.url())),
  };
}


export const BillingNoticePage = connect(mapStateToProps, mapDispatchToProps)(BillingNoticePageComponent);
